<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      line-form
      show-save-button
      unit="地区资料"
      edit-title
      id-key="DistrictId"
      :data="data"
      @create-opened="onCreateOpened"
      @opened="onOpened"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="上级地区" prop="Pid">
                <select-input
                  placeholder="选择上级地区"
                  :label="data.Pname"
                  v-model="data.Pid"
                  @click="openDialog"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="地区编号" prop="Code">
                {{data.Code}}
                <!-- <el-input v-model="data.Code" placeholder="请输入地区编号"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地区名称" prop="Name">
                <el-input v-model="data.Name" placeholder="请输入地区名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-head">运价信息</div>
        <el-row class="border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="运价一" prop="Freight1">
                <el-input v-model="data.Freight1" v-num placeholder="请输入运价"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运价二" prop="Freight2">
                <el-input v-model="data.Freight2" v-num placeholder="请输入运价"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="运价三" prop="Freight3">
                <el-input v-model="data.Freight3" v-num placeholder="请输入运价"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运价四" prop="Freight4">
                <el-input v-model="data.Freight4" v-num placeholder="请输入运价"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <list-dialog ref="listDialog" in-dialog selectable @select="onSelect" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import listDialog from "./listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    listDialog,
  },
  data() {
    return {
      data: {
        DistrictId: 0,
        Code: "",
        Name: "",
        Pid: null,
        Pcode: "",
        Pname: "",
        Freight1: null,
        Freight2: null,
        Freight3: null,
        Freight4: null,
      },
      api: require("@/api/ba/district").default,
      rules: {
        Code: [{ required: true, message: "地区编号不能为空" }],
        Name: [{ required: true, message: "地区名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    getMaxCode(Pid){
      this.api.getMaxCode(Pid).then(res=>{
         this.data.Code = res
      })
    },
    onCreateOpened(data) {
      this.getMaxCode(data.Pid)
    },
    onOpened() {
      // this.$refs.typeSelect.init();
    },
    openDialog() {
      this.$refs.listDialog.open().then((that) => {
        that.getData({ NoId: this.data.DistrictId });
      });
    },
    onSelect(data) {
      console.log("data", data);
      this.data.Pid = data.DistrictId;
      this.data.Pcode = data.Code;
      this.data.Pname = data.Name;
      this.getMaxCode(data.DistrictId)
    },
    onBeforeSave() {
      if (!this.data.Pid) this.data.Pcode = "";
      // console.log("data", JSON.parse(JSON.stringify(this.data)));
      // return false;
    },
  },
};
</script>